module.exports = __webpack_public_path__ + "static/media/navigate.851a7c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/navigate.png
// module id = 393
// module chunks = 0